import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2 4.25C2 3.00736 3.00736 2 4.25 2H13.75C14.9926 2 16 3.00736 16 4.25V8H19.75C20.9926 8 22 9.00736 22 10.25V19.75C22 20.9926 20.9926 22 19.75 22H10.25C9.00736 22 8 20.9926 8 19.75V16H4.25C3.00736 16 2 14.9926 2 13.75V4.25ZM10 19.75C10 19.8881 10.1119 20 10.25 20H19.75C19.8881 20 20 19.8881 20 19.75V10.25C20 10.1119 19.8881 10 19.75 10H10.25C10.1119 10 10 10.1119 10 10.25V19.75ZM14 8H10.25C9.00736 8 8 9.00736 8 10.25V14H4.25C4.11193 14 4 13.8881 4 13.75V4.25C4 4.11193 4.11193 4 4.25 4H13.75C13.8881 4 14 4.11193 14 4.25V8Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }